export default __webpack_public_path__ + "static/media/physical-activity-level.31e22e20.svg";